import { createAxiosClient } from "@ntg/component-library/utilities";
import { useQuery } from "@tanstack/react-query";
import { IServiceOrderInit } from "../../declarations/ServiceOrderInit";

const getServiceOrderInit = async (
    serviceOrderID: number,
): Promise<IServiceOrderInit> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.get<IServiceOrderInit>(
        `/ServiceOrder/GetServiceOrderInit/${serviceOrderID}`,
    );
    return response.data;
};

export const useGetServiceOrderInit = (serviceOrderID: number) =>
    useQuery<IServiceOrderInit>({
        enabled: serviceOrderID > 0,
        queryFn: () => getServiceOrderInit(serviceOrderID),
        queryKey: ["GetServiceOrderInit", serviceOrderID],
        refetchOnWindowFocus: false,
        retry: false,
    });
